<template>
  <div
    v-if="has_perm('view_invoice') || GET_ACCOUNT_DATA.id == 1"
    style="border: 0px solid black; width:100%;"
  >
    <div class="welcome" style="border: 0px solid red;">
      <row style="border:0px solid green;position: inherit;display:contents;width:100%;">
        <!--  -->
        <div class="box box-primary">
          <div class="box-header with-border">
            <row style="margin: 0">
              <div style="text-align:center; font-size: 17px;text-align:left;color:#5b6c7f;margin-bottom:20px;">
                <!-- <b>{{ $t("invoice.title") }}</b> -->
                <!-- <lte-button style="float:right;background-color:white !important;"
                                        type="btn btn-default" right_icon="fa
                                        fa-retweet" @click="onChangeIssuedToPaid($event)">{{$t('invoice.change_issued_to_paid')}}</lte-button> -->
                <lte-button
                  style="float:right"
                  type="btn btn btn-success"
                  right_icon="fa fa-download"
                  @click="onExport($event)"
                >{{ $t("invoice.export") }}</lte-button>
                <!-- <lte-button
                  v-if="has_perm('create_send_notification') || GET_ACCOUNT_DATA.id == 1"
                  style="float:right;background-color:white !important;"
                  type="btn btn-default"
                  right_icon="fa fa fa-print"
                  @click="showModalConfirmSendPdf(true)"
                  >{{ $t("common.sendPdf") }}</lte-button> -->
                <div
                  class="btn-group pull-right"
                  v-if="GET_ACCOUNT_DATA.id == 1 || has_perm('print_invoice')">
                  <button
                    type="button"
                    class="btn btn-default dropdown-toggle"
                    style="background-color:white !important; margin: 1px"
                    data-toggle="dropdown"
                    aria-expanded="true"
                  >
                    <i class="fa fa-print"></i>
                    {{ $t("common.printPdf") }}
                  </button>
                  <ul
                    class="dropdown-menu dropdown-menu-left hide-scroll-bar"
                    style="min-width: 50px;max-height: 80px;">
                    <li
                      class="send-email-invoice-item"
                      style="white-space: nowrap;"
                      @click="onPrintInvoiceByFilter($event, printInvoiceType=sendInvoiceTypeEnum.PERIODIC)"
                    >
                      {{ $t('invoice.sendInvoiceType.PERIODIC') }}
                    </li>
                    <li
                      class="send-email-invoice-item"
                      style="white-space: nowrap;"
                      @click="onPrintInvoiceByFilter($event, printInvoiceType=sendInvoiceTypeEnum.REMINDER)"
                    >
                      {{ $t('invoice.sendInvoiceType.REMINDER') }}
                    </li>
                  </ul>
                </div>
                <!-- <lte-button
                  style="float:right"
                  type="btn btn-primary"
                  v-if="GET_ACCOUNT_DATA.id == 1 || has_perm('create_invoice')"
                  right_icon="fa fa-plus"
                  @click="addNew($event)"
                  >{{ $t("invoice.addnew") }}</lte-button
                > -->
                <!-- <lte-button
                  style="float:right;"
                  type="btn btn-primary"
                  v-if="GET_ACCOUNT_DATA.id == 1 || has_perm('create_invoice')"
                  right_icon="fa fa-plus"
                  @click="onShowModalCreateLiabilities()"
                  >{{
                    $t("invoice.invoice_receipt.button_liability")
                  }}</lte-button
                > -->
                <!-- <lte-button
                  style="float:right"
                  type="btn btn btn-success"
                  v-if="has_perm('export_invoice') || GET_ACCOUNT_DATA.id == 1"
                  right_icon="fa fa-download"
                  @click="onConvertBkav()"
                  >{{
                    $t("invoice.invoice_receipt.button_convertblav")
                  }}</lte-button
                > -->
                <!-- <lte-button
                  style="float:right"
                  type="btn btn-success"
                  right_icon="fa fa-envelope"
                  v-if="GET_ACCOUNT_DATA.id == 1 || has_perm('create_invoice')"
                  @click="onShowModalSendInvoiceEmail"
                  >{{ $t("invoice.sendEmailInvoice") }}</lte-button
                > -->
                <div class="btn-group" style="float:right">
                  <button
                    type="button"
                    class="btn btn-success dropdown-toggle"
                    data-toggle="dropdown"
                    aria-expanded="true"
                  >
                    <i class="fa fa-envelope"></i>
                    {{ $t("invoice.sendEmailInvoice") }}
                  </button>
                  <ul
                    class="dropdown-menu hide-scroll-bar"
                    style="min-width: 50px;max-height: 80px;">
                    <li
                      class="send-email-invoice-item"
                      @click="onShowModalSendInvoiceEmail(sendInvoiceTypeEnum.PERIODIC)"
                    >
                      {{ $t('invoice.sendInvoiceType.sendPeriodic') }}
                    </li>
                    <li
                      class="send-email-invoice-item"
                      @click="onShowModalSendInvoiceEmail(sendInvoiceTypeEnum.REMINDER)"
                    >
                      {{ $t('invoice.sendInvoiceType.sendReminder') }}
                    </li>
                  </ul>
                </div>
                <lte-button
                  style="float:right"
                  type="btn btn-warning"
                  right_icon="fa fa-mobile"
                  v-if="GET_ACCOUNT_DATA.id == 1 || has_perm('create_invoice')"
                  @click="onShowModalSendNotification"
                  >{{ $t("invoice.sendNotificationInvoice") }}</lte-button
                >
                <lte-button
                  style="float:right"
                  type="btn btn-primary"
                  right_icon="fa fa-plus"
                  v-if="GET_ACCOUNT_DATA.id == 1 || has_perm('create_invoice')"
                  @click="importExcel"
                  >{{ $t("invoice.importFromExcel") }}</lte-button
                >
                <lte-button
                  v-if="has_perm('delete_invoice') || GET_ACCOUNT_DATA.id == 1"
                  style="float:right"
                  type="btn btn-danger"
                  right_icon="glyphicon glyphicon-remove"
                  @click="onShowModalDeleteInvoice()"
                  >{{ $t("invoice.button_delete_invoice") }}</lte-button
                >
              </div>
            </row>
            <div class="col-md-12" style="padding-right: 0">
              <select-option-check
                @callbackData="onColumnSelect"
                :item="columnsInvoice"
                class="dropdown-trigger"
                data-icon="eye"
              ></select-option-check>
            </div>
            <row style="padding: 0;">
              <div class="col-md-12 col-sm-12" style="float:right; text-align: right">
                <div style="display: inline-block; margin-right: 10px;">
                  <p style="display: inline-block">{{ $t("invoice.totalInvoice") }}</p>
                  <p style="background-color: #42b983;padding: 4px 15px 4px 15px;display: inline-block;border: 1px solid #fff;color: #fff; border-radius: 5px;">
                    {{ summaryTotalItem }}
                  </p>
                </div>
                <div style="display: inline-block; margin-right: 10px;">
                  <p style="display: inline-block">{{ $t("invoice.total") }}</p>
                  <p style="background-color: #c9302c;padding: 4px 15px 4px 15px;display: inline-block;border: 1px solid #fff;color: #fff; border-radius: 5px;">
                    {{ summaryCountTotal }}
                  </p>
                </div>
                <!-- <div style="display: inline-block; margin-right: 10px;">
                  <p style="display: inline-block">
                    {{ $t("reportLiabilitiesReport.open") }}
                  </p>
                  <p style="background-color: #3c8dbc;padding: 4px 15px 4px 15px;display: inline-block;border: 1px solid #fff;color: #fff; border-radius: 5px;">
                    {{ summaryCountNotPaid }}
                  </p>
                </div> -->
                <!-- <div style="display: inline-block;">
                  <p style="display: inline-block">
                    {{ $t("reportLiabilitiesReport.paid") }}
                  </p>
                  <p style="background-color: #f39c12;padding: 4px 15px 4px 15px;display: inline-block;border: 1px solid #fff;color: #fff; border-radius: 5px;">
                    {{ summaryCountPaid }}
                  </p>
                </div> -->
              </div>
              <div class="col-md-12 col-sm-12" style="float:right; text-align: right; font-size: 0.9em;">
                <div style="display: inline-block; margin-right: 10px;">
                  <p style="display: inline-block">{{ $t("invoice.numOfSelected") }}</p>
                  <p style="background-color: #42b983;padding: 4px 15px 4px 15px;display: inline-block;border: 1px solid #fff;color: #fff; border-radius: 5px;">
                    {{ invoiceInformationList.length }}
                  </p>
                </div>
                <div style="display: inline-block; margin-right: 10px;">
                  <p style="display: inline-block">{{ $t("invoice.total") }}</p>
                  <p style="background-color: #c9302c;padding: 4px 15px 4px 15px;display: inline-block;border: 1px solid #fff;color: #fff; border-radius: 5px;">
                    {{ countTotal }}
                  </p>
                </div>
                <!-- <div style="display: inline-block; margin-right: 10px;">
                  <p style="display: inline-block">
                    {{ $t("reportLiabilitiesReport.open") }}
                  </p>
                  <p style="background-color: #3c8dbc;padding: 4px 15px 4px 15px;display: inline-block;border: 1px solid #fff;color: #fff; border-radius: 5px;">
                    {{ countNotPaid }}
                  </p>
                </div> -->
                <!-- <div style="display: inline-block;">
                  <p style="display: inline-block">
                    {{ $t("reportLiabilitiesReport.paid") }}
                  </p>
                  <p style="background-color: #f39c12;padding: 4px 15px 4px 15px;display: inline-block;border: 1px solid #fff;color: #fff; border-radius: 5px;">
                    {{ countPaid }}
                  </p>
                </div> -->
              </div>
            </row>
          </div>
          <div class="box-body">
            <row>
              <div class="box-body col-md-4 col-sm-4" style="display: inline-block;float:left; text-align: left">
                <div class="input-group type">
                  <div class="input-group-addon" style="border-color: #337ab7; background-color: #337ab7; color: white">
                    <i class="fa fa-file-text-o"></i>
                  </div>
                  <select
                    class="form-control"
                    :placeholder="$t('apartmentGroup.title')"
                    style="border-color: #337ab7; background-color: #337ab7; color: white; width: 250px"
                    v-model="invoiceType"
                    @change="onEmitSelectInvoiceType"
                    >
                    <option
                      v-for="(item, index) in invoiceTypeList"
                      :key="item+index"
                      :value="item.value"
                    >
                      {{ $t('invoice.invoiceSelected', {name: $t(item.text)}) }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="box-body col-md-8 col-sm-8">
                <apartment-group-filter-component
                  :btnDropDownTitle="btnDropDownTitle"
                  :isFilter="true"
                  :isHideNumberApartment="true"
                  :isHideManagementApartmentGroup="true"
                  @emitFilterApartmentInGroup="emitFilterApartmentInGroup"
                />
              </div>
            </row>
            <lte-table
              ref="lteTable"
              :hdBackground="hdBackground"
              :data="gridInvoiceDataList"
              :columns="gridColumns"
              :useFilter="useFilter"
              search_filter="left-search"
              @actions="crudActions"
              :actions="getActions()"
              :useCheckBox="useCheckBox"
              @selectedItems="selectedItems"
              @searchQuery="filterData"
              :boxStyle="boxStyle"
              :isGetInformationInvoice="true"
              :row_mouse_pointer="false"
              :status_field="status_field"
              :customColumns="customColumns"
              :customActionKey="customActionKey"
              :isCustomActions="true"
            >
            </lte-table>
          </div>
        </div>
        <!--  -->

        <div class="box-footer clearfix" style="display:contents;" v-if="gridInvoiceDataList.length > 0">
          <paginator :item="paginatorItem" @onpaginate="onPagination" />
        </div>

        <lte-modal
          v-show="isModalVisible"
          @onConfirm="onConfirm"
          @close="closeModal"
          v-for="obj in objModal"
          :key="obj.id"
          :item="obj"
          :dataRow="originalRecordData"
          :customStyle="'customerStyle'"
        />

        <lte-modal
          v-show="isModalVisibleChangedIssueToPaid"
          @onConfirm="onConfirmChangedIssueToPaid"
          @close="closeModal"
          v-for="obj in objModalChangedIssueToPaid"
          :key="obj.id"
          :item="obj"
        ></lte-modal>

        <lte-core-alert
          v-for="snackbar in GET_SNACK_BAR"
          :key="snackbar.id"
          :item="snackbar"
        ></lte-core-alert>
        <loading
          :active.sync="isLoading"
          :can-cancel="false"
          color="#1E90FF"
        ></loading>
      </row>
    </div>

    <!-- BEGIN - Modal modal-main-liability -->
    <div class="modal fade" :ref="`modal-main-liability`">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">{{ $t("invoice.liability.title") }}</h4>
          </div>
          <div class="modal-body">
            <!-- <p>{{$t('invoice.liability.confirm', {'0': list_invoice_id})}}</p> -->
            <div class="row">
              <div
                v-if="invoiceNotExportLiabilitList.length != 0"
                class="col-sm-12"
              >
                <span style="color: red; font-weight: bold"
                  >* Danh sách phiếu báo dưới đây đã được chuyển vô công nợ nên
                  không thể chuyển nữa</span
                >
                <b-table
                  style="white-space: nowrap; max-height: 200px; overflow-y:auto;"
                  responsive
                  :items="invoiceNotExportLiabilitList"
                  :fields="invoiceLiabilitFields"
                  class="mt-3"
                  outlined
                >
                  <template #head()="scope">
                    <div>{{ $t(scope.label) }}</div>
                  </template>
                </b-table>
              </div>
              <div class="col-sm-12">
                <span style="margin: 10px 0 10px 0; font-weight: bold"
                  >Danh sách phiếu báo có thể chuyển vô công nợ</span
                >
                <b-table
                  style="white-space: nowrap; max-height: 200px; overflow-y:auto;"
                  responsive
                  :items="invoiceExportLiabilitList"
                  :fields="invoiceLiabilitFields"
                  class="mt-3"
                  outlined
                >
                  <!-- <template
                    v-for="index in invoiceLiabilitFields"
                    :slot="'HEAD_' + index.key"
                    slot-scope="item"
                  >
                    {{ $t(item.label) }}
                  </template> -->
                  <template #head()="scope">
                    <div>{{ $t(scope.label) }}</div>
                  </template>
                </b-table>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              style="background-color: #f29911;border-color: #f29911;color:#fff"
              type="button"
              class="btn btn-default pull-left"
              data-dismiss="modal"
            >
              {{ $t("common.back") }}
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="onSaveLiability"
            >
              {{ $t("common.confirm") }}
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- END - /.Modal modal-main-liability -->

    <!-- Modal modal-main-print -->
    <!-- <div class="modal fade" :ref="`modal-main-print`">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">{{ $t("invoice.template_print") }}</h4>
          </div>
          <div class="modal-body">
            <div class="row mb-1 margin-down-15">
              <div class="col-md-3">{{ $t("invoice.template_print") }}</div>
              <div class="col-md-6">
                <b-form-select
                  :options="get_template"
                  v-model="template_selected"
                  class="form-control"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              style="background-color: #f29911;border-color: #f29911;color:#fff"
              type="button"
              class="btn btn-default pull-left"
              data-dismiss="modal"
            >
              {{ $t("common.back") }}
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="onPrintInvoice"
            >
              {{ $t("common.printPdf") }}
            </button>
          </div>
        </div>
      </div>
    </div> -->
    <!-- /.modal -->

    <!-- Modal modal-main-print-search -->
    <div class="modal fade" :ref="`modal-main-print-search`">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">{{ $t("invoice.template_print") }}</h4>
          </div>
          <div class="modal-body">
            <div class="row label_choose_print">
              <!-- BEGIN - Print Pdf With choosing -->
              <div class="form-group">
                <label
                  for="name"
                  class="col-md-3 col-sm-3 control-label"
                  style="margin-top:13px;"
                  >{{ $t("invoice.label_choose_print") }}</label
                >
                <div class="col-md-6 col-sm-6">
                  <div class="radio">
                    <label>
                      <input
                        type="radio"
                        name="optionsRadiosInvoice"
                        id="optionsRadiosInvoice1"
                        value="1"
                        v-model="picked"
                        checked
                      />
                      {{ $t("invoice.by_month") }}
                    </label>
                    <label style="margin-left:30px;"></label>
                    <label>
                      <input
                        type="radio"
                        name="optionsRadiosInvoice"
                        id="optionsRadiosInvoice2"
                        value="2"
                        v-model="picked"
                      />
                      {{
                        $t("invoice.modal_create_liabilities.label_by_selected")
                      }}
                    </label>
                  </div>
                </div>
                <!-- /.input group -->
              </div>
            </div>

            <div class="row mt-2 mb-1 margin-down-15" v-if="picked == 1">
              <!-- BEGIN - Month From -->

              <div class="form-group">
                <label for="name" class="col-md-3 col-sm-3 control-label">{{
                  $t("invoice.month")
                }}</label>

                <div class="col-md-6 col-sm-6">
                  <date-picker
                    :config="optionsPicker"
                    v-model="periodSelected"
                  ></date-picker>
                </div>
              </div>
            </div>

            <br />

            <div class="row mt-2 mb-1 margin-down-15" v-if="printInvoiceType==sendInvoiceTypeEnum.REMINDER">
              <div class="form-group">
                <label for="name" class="col-md-3 col-sm-3 control-label">{{
                  $t("Hạn thanh toán")
                }}</label>
                <div class="col-md-6 col-sm-6">
                  <date-picker
                    :config="optionsPickerRemider"
                    v-model="lastPaymentDate"
                  ></date-picker>
                </div>
              </div>
            </div>

            <br />

            <!-- END - Month From -->
            <!-- <div class="row mb-1 margin-down-15">
              <div class="col-md-3">{{ $t("invoice.template_print") }}</div>
              <div class="col-md-6">
                <b-form-select
                  :options="get_template"
                  v-model="template_selected"
                  class="form-control"
                />
              </div>
            </div> -->

            <!-- <b-form-checkbox-group
              v-model="SquareChecked"
              id="checkboxesInvoice"
            >
              <label for="name" class="checkbox_has_amount">{{
                $t("invoice.has_amount")
              }}</label>
              <b-form-checkbox value="0"> </b-form-checkbox>
            </b-form-checkbox-group> -->
          </div>
          <div class="modal-footer">
            <button
              style="background-color: #f29911;border-color: #f29911;color:#fff"
              type="button"
              class="btn btn-default pull-left"
              data-dismiss="modal"
            >
              {{ $t("common.back") }}
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="onPrintInvoiceSearch"
            >
              {{ $t("common.printPdf") }}
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -search-->

    <!-- Modal modal-main-print-search -->
    <div class="modal fade" :ref="`modal-main-export-excel`">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">{{ $t("invoice.export_title") }}</h4>
          </div>
          <div class="modal-body">
            <div class="row mb-1 margin-down-15">
              <div class="form-group">
                <label
                  for="name"
                  class="col-md-3 col-sm-3 control-label"
                  style="margin-top:13px;"
                  >{{ $t("invoice.export") }}</label
                >
                <div class="col-md-6 col-sm-6">
                  <div class="radio">
                    <label>
                      <input
                        type="radio"
                        name="optionsRadios"
                        id="optionsRadios1"
                        value="1"
                        v-model="picked"
                        checked
                      />
                      {{ $t("invoice.by_month") }}
                    </label>
                    <label style="margin-left:30px;"></label>
                    <label>
                      <input
                        type="radio"
                        name="optionsRadios"
                        id="optionsRadios2"
                        value="2"
                        v-model="picked"
                      />
                      {{ $t("invoice.by_search") }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-show="picked == 1"
              class="row mb-1 margin-down-15"
              style="margin-top:10px;"
            >
              <!-- BEGIN - Month From -->
              <div class="form-group">
                <label for="name" class="col-md-3 col-sm-3 control-label">{{
                  $t("invoice.month")
                }}</label>
                <div class="col-md-6 col-sm-6">
                  <date-picker
                    :config="optionsPicker"
                    v-model="periodSelected"
                  ></date-picker>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              style="background-color: #f29911;border-color: #f29911;color:#fff"
              type="button"
              class="btn btn-default pull-left"
              data-dismiss="modal"
            >
              {{ $t("common.back") }}
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="onExportInvoiceToExcel"
            >
              {{ $t("invoice.export") }}
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>

    <!-- Modal confirm send pdf to email -->
    <div class="modal fade" :ref="`modal-confirm-send-pdf`">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">{{ $t("invoice.send_email") }}</h4>
          </div>
          <div class="modal-body">
            <!-- send all with period -->
            <div
              style="margin-top:1rem"
              class="row mt-1 margin-up-15"
              v-if="isPrintMonth"
            >
              <div class="col-md-3">{{ $t("invoice.month") }}</div>
              <div class="form-group">
                <div class="col-md-6 col-sm-6">
                  <b-form-select
                    class="form-control select2"
                    style="width: 100%;"
                    tabindex="-1"
                    v-model="periodSelected"
                    :options="periods"
                    @change="onSelectedMonthSendMail"
                    :disabled="periodDisabledList ? false : true"
                  />
                </div>
                <!-- /.input group -->
              </div>
            </div>
            <br />
            <div class="row mb-1 margin-down-10">
              <span style="margin-left:15px" v-if="multipleSendPdf">{{
                $t("invoice.content_email_multiple")
              }}</span>
              <span style="margin-left:15px" v-else
                >{{ $t("invoice.content_email_single") }}
                <span style="font-weight:bold">{{ full_name }}</span
                >?</span
              >
            </div>
          </div>
          <div class="modal-footer">
            <button
              v-if="isPrintMonth"
              style="background-color: #f29911;border-color: #f29911;color:#fff"
              type="button"
              class="btn btn-default pull-left"
              @click="onCancel()"
            >
              {{ $t("common.back") }}
            </button>
            <button
              v-else
              style="background-color: #f29911;border-color: #f29911;color:#fff"
              type="button"
              class="btn btn-default pull-left"
              data-dismiss="modal"
            >
              {{ $t("common.back") }}
            </button>
            <button
              v-if="isPrintMonth"
              type="button"
              class="btn btn-primary"
              @click="onOpenModalWarning()"
            >
              {{ $t("common.confirm") }}
            </button>
            <button
              v-else
              type="button"
              class="btn btn-primary"
              @click="sendInvoiceEmailToUser()"
            >
              {{ $t("common.confirm") }}
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -search-->
    <!-- modal - warning - send - all - mail -->

    <div class="modal fade" :ref="`modal-warning-send-mail`">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title text-warning">{{ $t("warning.title") }}</h4>
          </div>
          <div class="modal-body">
            <div class="row mb-1 margin-down-15" style="margin-top:10px;">
              <!-- BEGIN - Month From -->
              <div class="form-group">
                <div style="padding:1rem">{{ $t("warning.warning_text") }}</div>
                <!-- /.input group -->
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              style="background-color: #f29911;border-color: #f29911;color:#fff"
              type="button"
              class="btn btn-default pull-left"
              @click="onCancel()"
            >
              {{ $t("common.back") }}
            </button>
            <button
              type="button"
              class="btn btn-primary"
              :disabled="check_fetchalldata == false"
              @click="onSendPdfToEmail(1)"
            >
              {{ $t("common.confirm") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" :ref="`modal-process-payment`">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title text-warning">{{ $t("receipt.issued_receipt", { apartment: originalRecordData['apartment_code'] }) }}</h4>
          </div>
          <div class="modal-body">
            <div class="row mb-1 margin-down-15">
              <div class="form-group">
                <span class="col-md-12 col-sm-12">
                  {{ $t('receipt.from_invoice') }} <b>{{ originalRecordData['invoice_number'] }}</b>
                </span>
                <span class="col-md-12 col-sm-12">
                  {{ $t('receipt.total_payment') }} <b>{{ originalRecordData['invoice.total_fees'] }}</b>
                </span>
                <span
                  class="col-md-3 col-sm-3 control-label"
                  style="margin-top:13px;"
                  >&nbsp;
                </span>
                <div class="col-md-6 col-sm-6">
                  <div class="radio">
                    <label>
                      <input
                        type="radio"
                        name="optionsRadios"
                        id="optionsRadios1"
                        value="1"
                        v-model="picked"
                        checked
                      />
                      {{ $t("receipt.full") }}
                    </label>
                    <label style="margin-left:30px;"></label>
                    <label>
                      <input
                        type="radio"
                        name="optionsRadios"
                        id="optionsRadios2"
                        value="2"
                        v-model="picked"
                      />
                      {{ $t("receipt.partial") }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-show="picked == 2"
              class="row mb-1 margin-down-15"
              style="margin-top:10px;"
            >
              <div class="form-group">
                <span class="col-md-3 col-sm-3 control-label">{{ $t("receipt.pay_amount") }}</span>
                <div class="col-md-8 col-sm-8">
                  <input
                    class="form-control"
                    type="number"
                    min="0"
                    :placeholder="$t('receipt.receipt_customer.number_of_money')"
                    v-model="paymentValue"
                  />
                </div>
              </div>
            </div>
            <div
              class="row mb-1 margin-down-15"
              style="margin-top:10px;"
            >
              <div class="form-group">
                <span class="col-md-3 col-sm-3 control-label">{{ $t("common.notes") }}</span>
                <div class="col-md-8 col-sm-8">
                  <textarea
                    class="form-control"
                    rows="3"
                    :placeholder="$t('common.notes')"
                    v-model="paymentNote"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              style="background-color: #f29911;border-color: #f29911;color:#fff"
              type="button"
              class="btn btn-default pull-left"
              data-dismiss="modal"
            >
              {{ $t("common.back") }}
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="onProcessPayment(originalRecordData)"
            >
              {{ $t("common.confirm") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- /modal  -->
    <!-- Modal Convert BKav -->
    <div class="modal fade" :ref="`modal-convert-bkav`">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">Xuất Hóa Đơn Điện Tử</h4>
          </div>
          <div class="modal-body">
            <div class="row mb-1 margin-down-15" style="margin-top:10px;">
              <!-- BEGIN - Month From -->
              <div class="form-group">
                <label for="name" class="col-md-3 col-sm-3 control-label">{{
                  $t("invoice.month")
                }}</label>
                <div class="col-md-6 col-sm-6">
                  <b-form-select
                    class="form-control select2"
                    style="width: 100%;"
                    tabindex="-1"
                    v-model="bkavPeriodSelected"
                    :options="periods"
                    @change="onSelectedMonth"
                    :disabled="periodDisabledList ? false : true"
                  />
                </div>
                <!-- /.input group -->
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              style="background-color: #f29911;border-color: #f29911;color:#fff"
              type="button"
              class="btn btn-default pull-left"
              data-dismiss="modal"
            >
              {{ $t("common.back") }}
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="convertToBkav"
            >
              Xuất
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->
    <!-- END Modal Booking Payment -->
    <modal-create-liabilities
      ref="showModalCreateLiabilities"
      @callBackActionCreateLiabilities="callBackActionCreateLiabilities"
    ></modal-create-liabilities>

    <modal-delete-invoice
      ref="onShowModalDeleteInvoice"
      :invoiceType="invoiceType"
      :modalTitle="modalTitle"
      @callBackActionDeleteInvoice="callBackActionDeleteInvoice"
    ></modal-delete-invoice>
    <sendEmailAndNotificationInvoice
      :periodDataList="periods"
      ref="sendEmailAndNotificationInvoice"
      @callbackInvoiceList="callbackInvoiceList"/>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { LTEActionTypeEnum } from '@/components/LTEEnum'
import LTEButton from "@/components/LTEButton.vue";
import LTETable from "@/components/LTETable.vue";
import LTEModal from "@/components/LTEModal.vue";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import XLSX from "xlsx";
import moment from "moment";
import Paginator from "@/components/Paginator.vue";
import datePicker from "vue-bootstrap-datetimepicker";
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
import Loading from "vue-loading-overlay";
import i18n from "../../lang";
import utils from '@/lib/utils';
import SelectOptionCheck from "@/components/SelectOptionCheck.vue";
import InvoiceTemplateEnum from "@/enum/invoiceTemplateEnum"

import ModalDeleteInvoice from "./ModalDeleteInvoice";
import ModalCreateLiabilities from "./ModalCreateLiabilities";
import sendEmailAndNotificationInvoice from "./SendEmailAndNotificationInvoice"
import ApartmentGroupFilterComponent from "../Apartment/ApartmentGroupFilterComponent.vue"
import Enum from "../../../enum/enum"

//import ConvertToBKAV from './ConvertToBKAV'

export default {
  name: "InvoiceList",
  data() {
    return {
      defaultPage: 1,
      picked: 1,
      buttonName: "danger",
      labelName: "Name",
      gridInvoiceDataList: [],
      filterDataOnTable: [],
      dataExport: [],
      SquareChecked: 1,
      check_fetchalldata: false,
      isPrintMonth: false,
      boxStyle: false,
      status_field: {
        exported_to_liability: 1
      },
      optionsPicker: {
        useCurrent: false,
        minDate: new Date(2019, 0),
        format: "YYYY/MM",
        locale: this.$i18n.locale == "en" ? "en" : "vi",
      },
      optionsPickerRemider: {
        useCurrent: false,
        minDate: new Date(),
        format: "DD/MM/YYYY",
        locale: this.$i18n.locale == "en" ? "en" : "vi",
      },
      gridColumns: [
        { text: "invoice.invoice_number", isHidden: true, wrapText: 'nowrap' },
        { text: "invoice.apartment_code", isHidden: true, align: 'center', wrapText: 'nowrap' },
        { text: "invoice.owner", isHidden: true, width: '250px' },
        { text: "receiptReceiveInfo.emailReceiveReceipt", isHidden: true },
        // { text: "invoice.status_name", isHidden: true },
        { text: "common.dateCreate", isHidden: true, align: 'center' },
        //   { text: "invoice.date_paid", isHidden: true },
        { text: "invoice.total_fees", isHidden: true, align: 'right' },
        { text: "invoice.due_date", isHidden: true, align: 'center' },
        { text: "invoice.userCreated", isHidden: true, width: '150px' },
        { text: "invoice.app", isHidden: true, align: 'center' },
        { text: "common.email", isHidden: true, align: 'center' }
        //   { text: "invoice.note", isHidden: true }
      ],
      columnsInvoice: {
        data_list: [],
        itemType: 1,
        showLabel: false,
        modifyFromPosition: "margin-top:-300px",
        cssClassSm1: "col-md-1",
        cssClassSm2: "col-sm-1",
        showAddNew: false
      },
      columnsInvoiceStatus: {
        data_list: [],
        itemType: 1,
        showLabel: false,
        modifyFromPosition: "margin-top:-300px",
        cssClassSm1: "col-md-1",
        cssClassSm2: "col-sm-1",
        showAddNew: false,
        isSelectInvoiceStatus: true
      },
      hdBackground: "background-color: #4b646f;color:white;border:1px solid white;", //00a65a
      tblBorder: "border: 1px solid orange",
      originalRecordData: [],
      isModalVisible: false,
      useFilter: false,
      objModal: [
        {
          title: "common.delete_modal.title",
          body: "common.delete_modal.content_with_param",
          buttonNo: "common.delete_modal.btnNo",
          buttonYes: "common.delete_modal.btnYes",
          styleType: "default"
        }
      ],
      json_data_export: [],
      paginatorItem: {
        commit_function: "GET_INVOICE_LIST_PERFORMANCE_VS2"
      },
      search: {
        invoice_number: "",
        apartment_code: "",
        owner_apartment: "",
        user_name: "",
        status_name: "",
        date_issued: "",
        date_paid: "",
        other_details: "",
        total_fees: "",
        due_date: "",
        note: "",
        period: "",
        datePickerValue: "",
        dateCreatedInvoice: {
          start: null,
          end: null
        },
        status: null
      },
      isLoading: false,
      options: {
        format: "DD/MM/YYYY"
      },
      invoiceStatusSelect: [],
      periodsOnSearch: [{ text: "---", value: "" }],
      periods: [],
      periodDisabledList: true,
      periodSelected: null,
      lastPaymentDate: moment(new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate() + 5
      )).format("DD/MM/YYYY"),
      bkavPeriodSelected: null,
      useCheckBox: true,
      list_invoice_id: [],
      list_invoice_number: [],
      list_invoice_apartment_code: [],
      list_invoice_status_code: [],
      isModalVisibleChangedIssueToPaid: false,
      objModalChangedIssueToPaid: [
        {
          title: "Xác nhận thông tin thánh toán",
          body:
            "Bạn chắc chắn thanh toán các giấy báo đã chọn ( được phát hành ==> đã thanh toán ) ?",
          buttonNo: "Hủy",
          buttonYes: "Xác Nhận",
          styleType: "default"
        }
      ],
      customColumns: {
        "common.dateCreate": {
          date_curent: "label-darkcyan",
          date_last: "label-darkcyan"
        },
        "invoice.date_paid": {
          date_curent: "label-darkcyan",
          date_last: "label-crimson"
        },
        "invoice.due_date": {
          date_curent: "label-darkcyan",
          date_last: "label-crimson"
        },
        "invoice.apartment_code": {},
        "invoice.total_fees": {},
        "invoice.status_name": {
          Paid: "label-warning",
          Open: "label-warning",
          Issued: "label-primary",
          Cancelled: "label-danger",
          "Partial Paid": "label-darkcyan",

          "Đang Mở": "label-warning",
          "Đã trả": "label-warning",
          "Đã phát hành": "label-primary",
          "Đã hủy": "label-danger",
          "Đã trả một phần": "label-darkcyan"
        }
      },
      isViewDetail: "False",
      dateViewOption: "DD/MM/YYYY",
      invoiceInformationList: [],
      isSelectedAll: false,
      multipleSendPdf: true,
      full_name: "",
      // countPaid: 0,
      // countNotPaid: 0,
      countTotal: 0,
      summaryTotalItem: 0,
      // summaryCountPaid: 0,
      // summaryCountNotPaid: 0,
      summaryCountTotal: 0,
      invoiceNotExportLiabilitList: [],
      invoiceExportLiabilitList: [],
      invoiceLiabilitFields: [
        { key: "no", label: "#", sortable: true, class: "text-center" },
        {
          key: "invoice_number",
          label: "Số Phiếu Báo",
          sortable: true,
          class: "text-center"
        },
        {
          key: "apartment_code",
          label: "Mã Căn Hộ",
          sortable: true,
          class: "text-center"
        },
        {
          key: "owner_resident",
          label: "Thông Tin Chủ Hộ",
          sortable: true,
          class: "text-center"
        }
      ],
      customActionKey: [
        {
          headerKey: ["invoice.invoice_issue_date"],
          headerKeyValue: null,
          isEqualHeaderKeyValue: false,
          actionHide: 'common.delete'
        },
        {
          headerKey: ["isDeleted"],
          headerKeyValue: true,
          isEqualHeaderKeyValue: true,
          actionHide: 'common.delete'
        }
      ],
      btnDropDownTitle: 'apartment.apartmentGroupFilterTitle',
      apartmentGroupIdFilter: [],
      sendInvoiceTypeEnum: Enum.sendInvoiceTypeEnum,
      invoiceTypeList: [
        {
          value: Enum.invoiceTypeEnum.MONTHLY, text: 'invoice.monthlyFee'
        },
        {
          value: Enum.invoiceTypeEnum.QUATERLY, text: 'invoice.managementFee'
        }
      ],
      invoiceType: Enum.invoiceTypeEnum.MONTHLY,
      paymentValue: null,
      paymentNote: null,
      printInvoiceType: null,
      modalTitle: null
    };
  },
  watch: {
    GET_INVOICE_STATUS_DATA: function() {
      let params = this.$route.params;
      let data = this.GET_INVOICE_STATUS_DATA;
      let description = "";
      for (let i = 0, size = data.length; i < size; i++) {
        if (
          data[i].status_code == "O" ||
          data[i].status_code == "I" ||
          data[i].status_code == "P" ||
          data[i].status_code == "PP"
        ) {
          if (data[i].status_code == "O") {
            description = "invoice.invoice_status.O";
          } else if (data[i].status_code == "I") {
            description = "invoice.invoice_status.I";
          } else if (data[i].status_code == "P") {
            description = "invoice.invoice_status.P";
          } else if (data[i].status_code == "PP") {
            description = "invoice.invoice_status.PP";
          }
          if (this.isViewDetail == "True") {
            if (
              params.datasetLabel == this.$t("reportLiabilitiesReport.paid") &&
              (data[i].status_code == "P" || data[i].status_code == "PP")
            ) {
              this.invoiceStatusSelect.push(data[i].id);
              this.columnsInvoiceStatus.data_list.push({
                text: description,
                id: data[i].id,
                selected: "selected"
              });
            } else if (
              params.datasetLabel == this.$t("reportLiabilitiesReport.open") &&
              (data[i].status_code == "O" ||
                (data[i].status_code == "I" && data[i].status_code !== "C") ||
                (!utils.isNull(params.apartment) &&
                  data[i].status_code == "PP"))
            ) {
              this.invoiceStatusSelect.push(data[i].id);
              this.columnsInvoiceStatus.data_list.push({
                text: description,
                id: data[i].id,
                selected: "selected"
              });
            } else {
              this.columnsInvoiceStatus.data_list.push({
                text: description,
                id: data[i].id
              });
            }
            if (!utils.isNull(params.apartment)) {
              this.search.apartment_code = params.apartment;
            }
          } else {
            this.columnsInvoiceStatus.data_list.push({
              text: description,
              id: data[i].id
            });
          }
        }
      }
      if (this.isViewDetail == "True") {
        this.onSearchInvoice(1);
      }
    },
    GET_LANG: function() {
      this.optionsPicker.locale = this.$i18n.locale == "en" ? "en" : "vi";
      this.onSearchInvoice(1);
      this.columnsInvoiceStatus.data_list = [];
    },
    GET_INVOICE_DATA_PERFORMANCE_VS2: function() {
      let data = this.GET_INVOICE_DATA_PERFORMANCE_VS2;
      this.summaryTotalItem = utils.formatNumber(data.total_item)
      this.summaryCountTotal = utils.formatNumber(utils.makeRoundNumber(data.fee_total))
      // this.summaryCountPaid = utils.formatNumber(data.fee_paid)
      // this.summaryCountNotPaid = utils.formatNumber(data.fee_not_paid)
      this.gridInvoiceDataList = [];
      // let invoiceIssueds = []
      // let invoicePartialPaids = []
      // let invoicePaids = []
      // let invoiceLiability = []
      data.list_items.forEach(invoice => {
        // invoice.apartment = JSON.parse(invoice.apartment);
        invoice.invoice_status = !utils.isEmptyString(invoice.invoice_status) 
          ? JSON.parse(invoice.invoice_status) : null;

        let invoice_number = invoice.invoice_number;

        let apartment_code = "";
        let owner_apartment = "";
        let owner_apartment_email = ""

        if (utils.isNull(invoice.apartment) == false) {
          invoice.apartment = JSON.parse(invoice.apartment);
          apartment_code = invoice.apartment.apartment_code;

          let client_invoice = JSON.parse(invoice.client_invoice);
          owner_apartment = utils.getFullName(
            client_invoice.first_name,
            client_invoice.last_name,
            i18n.locale
          );
          owner_apartment_email = client_invoice.email
        }

        let language_status_name =
          "invoice.invoice_status." + invoice.invoice_status.status_code;
        // Get user export info
        let user_export_info = !utils.isNull(invoice.user_export_info)
          ? invoice.user_export_info
          : owner_apartment;
        let status_name = this.$t(language_status_name); //invoice.invoice_status.status_description;
        let status_code = !utils.isNull(invoice.invoice_status)
          ? invoice.invoice_status.status_code
          : null;

        let date_issued = utils.formatSqlDate(invoice.date_issued, null, "DD/MM/YYYY");
        let due_date = utils.formatSqlDate(invoice.date_payment_invoice, null, "DD/MM/YYYY", "");
        let date_paid = utils.formatSqlDate(invoice.date_paid, null, "DD/MM/YYYY", "");
        let total_fees = invoice.apartment_monthly_total_fees ? utils.formatNumber(utils.makeRoundNumber(invoice.apartment_monthly_total_fees)) : '0';
        let id = invoice && invoice.id;
        // let note = invoice && invoice.note;
        let exported_to_liability = invoice.exported_to_liability;
        let address = ""; // (utils.isNull(invoice.user.address)) ? invoice.apartment.apartment_code : invoice.user.address
        let phone = ""; //
        let userCreated = invoice.user_record.last_name + " " + invoice.user_record.first_name
        invoice.is_obsolete = JSON.parse(invoice.is_obsolete)
        invoice.is_deleted = JSON.parse(invoice.is_deleted)
        let data = {
          "invoice.invoice_number": invoice_number,
          "invoice.apartment_code": apartment_code,
          "invoice.owner": utils.capitalizeFirstInString(
            owner_apartment
          ),
          "invoice.user_name": utils.capitalizeFirstInString(user_export_info),
          "invoice.status_name": status_name,
          "invoice.status_code": status_code,
          "common.dateCreate": date_issued,
          "invoice.date_paid": date_paid,
          "invoice.total_fees": total_fees,
          "invoice.due_date": !utils.isEmptyString(due_date) ? due_date : this.getDateDueInvoiceData(),
          "invoice.userCreated": userCreated,
          "invoice.app": invoice.count_send_notification,
          "common.email": invoice.count_send_email,
          "receiptReceiveInfo.emailReceiveReceipt": utils.getCleanStringValue(invoice.receipt_receive_info_data.receipt_receive_email, owner_apartment_email),
          "invoice.invoice_issue_date": invoice.invoice_issue_date,
          "isDeleted": invoice.is_deleted,
          // "invoice.is_obsolete": {
          //   'value': invoice.is_obsolete,
          //   'color': invoice.is_obsolete ? "#dfdfdf" : ''
          // },
          backgroundRow: invoice.is_obsolete ? "#dfdfdf" : invoice.is_deleted ? '#ff868f' : '',
          // "invoice.note": note,
          id: id,
          invoice_number: invoice_number,
          apartment_code: apartment_code,
          partial_paid_list: invoice.partial_paid_list,
          exported_to_liability: exported_to_liability,

          address: address,
          phone: phone,
          total_liability_cash: !utils.isNull(invoice.total_liability_cash)
            ? utils.formatNumber(invoice.total_liability_cash)
            : null,
          liability_cash_surplus: !utils.isNull(invoice.liability_cash_surplus)
            ? utils.formatNumber(invoice.liability_cash_surplus)
            : null,
          period: invoice.period,
          disableCheckbox: invoice.is_obsolete || invoice.is_deleted ? true : false,
        };
        // Sort by date issued desc

        // if (status_code == 'I') {
        //     invoiceIssueds.unshift(data)
        // } else if (status_code == 'PP') {
        //     invoicePartialPaids.unshift(data)
        // } else if (status_code == 'P') {
        //     invoicePaids.unshift(data)
        // } else if (status_code == 'L') {
        //     invoiceLiability.unshift(data)
        // }
        this.gridInvoiceDataList.push(data);
      });
      // Sort by date issued desc
      // this.gridInvoiceDataList.unshift(...invoiceIssueds, ...invoicePartialPaids, ...invoicePaids, ...invoiceLiability)
      if (this.isPrintMonth == true) {
        setTimeout(() => {
          this.getDataAllItem();
          if (this.invoiceInformationList.length > 0) {
            // just for button confirm => true means alldata fetch and un disable button
            this.check_fetchalldata = true;
          }
        }, 1000);
      }
      // return this.gridInvoiceDataList;
      if (this.apartmentGroupIdFilter.length > 0) {
        this.$refs.lteTable.selectAllIdInvoice()
      }
    },

    GET_FILTER_INVOICE_DATA: function() {
      this.dataExport = [];

      this.GET_FILTER_INVOICE_DATA.forEach(invoice => {
        let invoice_number = invoice.invoice_number;

        let apartment_code = invoice.apartment == null ? "" : invoice.apartment.apartment_code;

        let status_name = invoice.invoice_status.status_description;
        let status_code = invoice.invoice_status.status_code;
        let date_issued = utils.formatSqlDate(invoice.date_issued, null, "DD/MM/YYYY");
        let due_date = utils.formatSqlDate(invoice.due_date, null, "DD/MM/YYYY", "");
        let date_paid = utils.formatSqlDate(invoice.date_paid, null, "DD/MM/YYYY", "");
        let total_fees = invoice.apartment_monthly_total_fees ? utils.formatNumber(invoice.apartment_monthly_total_fees) : '0';
        let id = invoice.id;
        let note = invoice.note;
        let owner_apartment = invoice.apartment == null ? "" : invoice.apartment.owner_apartment;
        // Get user export info
        let user_export_info = !utils.isNull(invoice.user_export_info) ? invoice.user_export_info : owner_apartment;
        let data = {
          "invoice.invoice_number": invoice_number,
          "invoice.apartment_code": apartment_code,
          "invoice.owner": owner_apartment,
          "invoice.user_name": user_export_info,
          "invoice.status_name": status_name,
          "invoice.status_code": status_code,
          "invoice.date_issued": date_issued,
          "invoice.date_paid": date_paid,
          "invoice.total_fees": total_fees,
          "invoice.due_date": due_date,
          "invoice.note": note,
          id: id,
          dateCreated: utils.formatSqlDate(invoice.date_created, null, "DD/MM/YYYY"),
          // emailReceiveReceipt: invoice.receipt_receive_info_data.receipt_receive_email,
          emailReceiveReceipt: utils.getCleanStringValue(invoice.receipt_receive_info_data.receipt_receive_email, invoice.user.email),
          inDebtValue: invoice.in_debt_value,
          serviceList: invoice.service_usage_list
        };
        this.dataExport.push(data);
      });

      return this.dataExport;
    },
    GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA: function() {
      if (!utils.isNull(this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.data)) {
        let newGridColumns = [];
        const viewedColumnsKey = Object.keys(
          this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.data.viewed_columns
        );
        const viewedColumns = this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.data
          .viewed_columns;
        for (
          let j = 0, sizeOrigin = this.gridColumns.length;
          j < sizeOrigin;
          j++
        ) {
          for (let i = 0, size = viewedColumnsKey.length; i < size; i++) {
            if (this.gridColumns[j].text == viewedColumnsKey[i]) {
              let viewdColumnObject = {};
              viewdColumnObject.text = viewedColumnsKey[i];
              viewdColumnObject.isHidden = viewedColumns[viewedColumnsKey[i]];
              newGridColumns.push(viewdColumnObject);
              break;
            }
          }
        }
        this.gridColumns = newGridColumns;
        this.columnsInvoice.data_list = this.gridColumns;
      }
    }
  },
  computed: {
    get_template: function() {
      let template_list = [
        { value: 4, text: "Template Republic" },
        { value: 5, text: "Template default" }
      ];
      return template_list;
    },
    ...mapGetters([
      "GET_SNACK_BAR",
      "PAGINATION",
      "PAGINATOR",
      "PAGE_ARROW",
      "GET_INVOICE_DATA_PERFORMANCE_VS2",
      "GET_FILTER_INVOICE_DATA",
      "GET_ACCOUNT_DATA",
      "GET_LANG",
      "GET_INVOICE_STATUS_DATA",
      "GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA"
    ])
  },
  methods: {
    getDataAllItem: function() {
      this.$refs.lteTable.selectAllIdInvoice();
    },
    onOpenModalWarning: function() {
      $(this.$refs["modal-warning-send-mail"]).modal("show");
    },
    getActions: function() {
      // if (this.has_perm('delete_invoice') && this.has_perm('create_send_notification')) {
      let action = [];
      if (this.GET_ACCOUNT_DATA.id == 1) {
        action.push(
          "common.modify",
          "common.delete",
          "common.printPdf",
          // "common.sendPdf"
        );
      } else {
        if (this.has_perm("update_invoice")) {
          action.push("common.modify");
        }
        if (this.has_perm("update_receipt_and_confirm")) {
          action.push("common.pay");
        }
        if (this.has_perm("delete_invoice")) {
          action.push("common.delete");
        }
        if (this.has_perm("print_invoice")) {
          action.push("common.print_invoice");
        }
        if (this.has_perm("create_send_notification")) {
          action.push("common.sendPdf");
        }
      }
      return action;
    },
    //START: actions related to convert bkav modal
    onToggleConvertBkavModal: function(action = "show") {
      $(this.$refs[`modal-convert-bkav`]).modal(action);
    },
    /*
     * author : [loitt]
     * function: call BackAction Delete Invoice
     *       Refresh data after delete
     */
    onShowModalCreateLiabilities: function() {
      this.$refs.showModalCreateLiabilities.submit(
        this.GET_ACCOUNT_DATA.id,
        this.invoiceInformationList,
        this.periods,
        this.invoiceLiabilitFields,
        this.invoiceExportLiabilitList,
        this.invoiceNotExportLiabilitList,
        this.list_invoice_id
      );
    },
    callBackActionCreateLiabilities: function() {
      this.onSearchInvoice(1);
      this.list_invoice_id = [];
      this.invoiceInformationList = [];
      this.invoiceNotExportLiabilitList = [];
      this.invoiceExportLiabilitList = [];
    },
    callBackActionDeleteInvoice: function() {
      this.onSearchInvoice(1);
      this.list_invoice_id = [];
      this.list_invoice_number = [];
      this.list_invoice_apartment_code = [];
      // this.countPaid = 0;
      // this.countNotPaid = 0;
      this.countTotal = 0;
      this.$refs.lteTable.removeSelected();
    },

    /*
     * author : [loitt]
     * function: Show modal delete invoice
     */
    onShowModalDeleteInvoice: function() {
      this.$refs.onShowModalDeleteInvoice.submit(
        this.periods,
        this.list_invoice_id,
        this.list_invoice_number,
        this.list_invoice_apartment_code
      );
    },

    onConvertBkav: function() {
      this.onToggleConvertBkavModal();
    },
    convertToBkav: function() {
      this.onToggleConvertBkavModal("hide");
      this.CONVERT_TO_EINVOICE_BKAV({ period: this.bkavPeriodSelected }).then(
          function() {
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function(error) {
            this.ERROR_TOAST();
          }.bind(this)
        );
    },
    showModalConfirmSendPdf: function(multipleSendPdf) {
      this.multipleSendPdf = multipleSendPdf;
      if (this.multipleSendPdf) {
        if (this.invoiceInformationList.length > 0) {
          $(this.$refs["modal-confirm-send-pdf"]).modal("show");
        } else {
          this.ON_SHOW_TOAST({
            message: "Vui lòng chọn phiếu báo để gửi",
            styleType: "danger"
          });
        }
      } else {
        $(this.$refs["modal-confirm-send-pdf"]).modal("show");
      }
    },

    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    onSelectInvoiceStatus: function(data) {
      if (this.invoiceStatusSelect.indexOf(parseInt(data.id)) == -1) {
        this.invoiceStatusSelect.push(parseInt(data.id));
      }
    },
    onUnselectInvoiceStatus: function(data) {
      if (this.invoiceStatusSelect.indexOf(parseInt(data.id)) != -1) {
        this.invoiceStatusSelect.splice(
          this.invoiceStatusSelect.indexOf(parseInt(data.id)),
          1
        );
      }
    },
    onColumnSelect: function(tables) {
      let tableDataObj = {};
      let tableDataObjChild = {};
      tableDataObjChild["tablename"] = "invoicelist";
      tables.data_list.forEach(element => {
        tableDataObj[element.text] = element.isHidden;
      });
      tableDataObjChild["tablerow"] = tableDataObj;
      this.SAVE_CUSTOMIZE_TABLE_PERSONAL_CONFIG(tableDataObjChild)
        .then(function() {}.bind(this))
        .catch(function() {}.bind(this));
    },
    getDataExportExcel(v) {
      // let language_status_name =
      //   "invoice.invoice_status." + v["invoice.status_code"];
      // let status_name = this.$t(language_status_name); //invoice.invoice_status.status_description;
      let electricAndWaterServiceFee = this.getElectricAndWaterServiceFee(v.serviceList)
      if (utils.isEnglishLanguage(i18n.locale)) {
        let data = {
          "Invoice Number": v["invoice.invoice_number"],
          "Apartment Code": v["invoice.apartment_code"],
          "Apartment Owner Information": utils.ucFirstAllWords(v["invoice.owner"]),
          "Email Receive Receipt": v.emailReceiveReceipt,
          "Date Create": v.dateCreated,
          'Electricity Fee': electricAndWaterServiceFee.electricFee,
          'Water Fee': electricAndWaterServiceFee.waterFee,
          'Total Fee': utils.formatInteger( v["invoice.total_fees"]),
          'In debt': v.inDebtValue < 0 ? `(${v.inDebtValue})` : !utils.isEmptyString(v.inDebtValue) ? `${v.inDebtValue}` : null
          // "User Name": utils.ucFirstAllWords(v["invoice.user_name"]),
          // Status: status_name,
          // "Date Issued": v["common.dateCreate"],
          // "Date Paid": v["invoice.date_paid"],
          // //"Total Fees": utils.formatInteger( v["invoice.total_fees"]),
          // "Tổng Phí": parseInt(v["invoice.total_fees"].replace(/,/g, "")),
          // "Due Date": v["invoice.due_date"],
          // Note: v["invoice.note"]
        };
        return data;
      } else {
        let data = {
          "Mã Thanh Toán": v["invoice.invoice_number"],
          "Mã Căn Hộ": v["invoice.apartment_code"],
          "Thông Tin Chủ Hộ": utils.ucFirstAllWords(
            v["invoice.owner"]
          ),
          'Email Nhận Thông Báo': v.emailReceiveReceipt,
          'Ngày Tạo': v.dateCreated,
          'Tiền Điện': electricAndWaterServiceFee.electricFee,
          'Tiền Nước': electricAndWaterServiceFee.waterFee,
          'Tổng Phí': utils.formatInteger( v["invoice.total_fees"]),
          'Dư Nợ': v.inDebtValue < 0 ? `(${v.inDebtValue})` : !utils.isEmptyString(v.inDebtValue) ? `${v.inDebtValue}` : null
          // "Xuất Hóa Đơn Tới": utils.ucFirstAllWords(v["invoice.user_name"]),
          // "Tình Trạng": status_name,
          // "Ngày Phát Hành": v["common.dateCreate"],
          // "Ngày Trả": v["invoice.date_paid"],
          // //"Tổng Phí": utils.formatInteger( v["invoice.total_fees"]),
          // "Tổng Phí": parseInt(v["invoice.total_fees"].replace(/,/g, "")),
          // "Hạn Chót": v["invoice.due_date"],
          // "Ghi Chú": v["invoice.note"]
        };
        return data;
      }
    },
    getElectricAndWaterServiceFee: function(serviceList) {
      let ServiceIdEnum = Enum.ServiceIdEnum
      let electricService = serviceList.filter(x=>x.service_id===ServiceIdEnum.ELECTRIC)
      let waterService = serviceList.filter(x=>x.service_id===ServiceIdEnum.WATER)
      return {
        'electricFee': electricService.length > 0 ? electricService[0].total_fees : null,
        'waterFee': waterService.length > 0 ? waterService[0].total_fees : null
      }
    },
    onRefsDataSearch: function (data) {
      this.invoiceType = data.invoice_type
      this.search.invoice_number = data.invoice_number
      this.search.apartment_code = data.apartment_code
      this.search.owner_apartment = data.owner_apartment
      this.search.user_name = data.user_name
      this.search.date_issued = data.date_issued
      this.search.date_paid = data.date_paid
      this.search.other_details = data.other_details
      this.search.total_fees = data.total_fees
      this.search.due_date = data.due_date
      this.search.note = data.note
      this.search.period = data.period
      this.search.datePickerValue = data.datePickerValue
      this.search.dateCreatedInvoice.start = data.dateCreatedInvoiceFrom
      this.search.dateCreatedInvoice.end = data.dateCreatedInvoiceTo
      this.search.status = data.invoiceStatus
      this.onChangeSeviceInvoiceType()
      this.selectedItems([], false)
      this.onSearchInvoice(1)
    },
    onSearchInvoice(page) {
      // Remove selected item in table before search
      this.$refs.lteTable.removeSelected();

      const data = {
        params: {
          page: page,
          invoice_number: this.search.invoice_number,
          apartment_code: this.search.apartment_code,
          owner_apartment: !utils.isEmptyString(this.search.owner_apartment) ? this.search.owner_apartment.toLowerCase() : null,
          user_name: this.search.user_name,
          status_name: this.invoiceStatusSelect,
          date_issued: this.search.date_issued,
          date_paid: this.search.date_paid,
          other_details: this.search.other_details,
          total_fees: this.search.total_fees,
          due_date: this.search.due_date,
          note: this.search.note,
          period: this.search.period,
          dateViewOptions: this.dateViewOption,
          isViewDetail: this.isViewDetail,
          accountingPeriod: this.search.datePickerValue,
          invoiceType: this.invoiceType,
          apartmentGroupIdFilter: this.apartmentGroupIdFilter,
          dateCreatedInvoiceFrom: this.search.dateCreatedInvoice.start,
          dateCreatedInvoiceTo: this.search.dateCreatedInvoice.end,
          invoiceStatus: this.search.status
        }
      };
      this.isLoading = true;
      this.GET_INVOICE_LIST_PERFORMANCE_VS2(data).then(
        function() {
          this.isLoading = false;
        }.bind(this)
      )
      // .catch(
      //   function() {
      //     this.isLoading = false;
      //     this.ERROR_TOAST()
      //   }.bind(this)
      // );
    },
    onPrintInvoice() {
      let routeData = this.$router.resolve({
        name: "InvoicePdfFilter",
        query: {
          templateId: utils.getSessionKeyInt('invoiceTemplate', InvoiceTemplateEnum.REPUBLIC_PALAZA),
          invoiceType: this.invoiceType,
          list_invoice_ids: this.originalRecordData["id"],
          is_price_contain: 1,
          picked: 2
        }
      });
      window.open(routeData.href, "_blank");
    },
    getUnselectItems() {
      if (this.isSelectedAll) {
        let unselected_item = []
        this.gridInvoiceDataList.forEach(invoice => {
          if (this.list_invoice_id.indexOf(invoice.id) == -1) {
            unselected_item.push(invoice.id)
          }
        })
        return unselected_item
      } else {
        return null
      }
    },
    onPrintInvoiceSearch() {
      let searchData = {
        invoiceNumber: this.search.invoice_number,
        apartmentCode: this.search.apartment_code,
        ownerApartment: !utils.isEmptyString(this.search.owner_apartment) ? this.search.owner_apartment.toLowerCase() : null,
        accountingPeriod: this.search.datePickerValue,
        apartmentGroupIdFilter: this.apartmentGroupIdFilter,
        dateCreatedInvoiceFrom: this.search.dateCreatedInvoice.start,
        dateCreatedInvoiceTo: this.search.dateCreatedInvoice.end,
        invoiceStatus: this.search.status
      }
      let list_ids = this.isSelectedAll ? null : this.list_invoice_id
      let list_exclude_ids = this.getUnselectItems()
      let routeData = this.$router.resolve({
        name: "InvoicePdfFilter",
        query: {
          templateId: utils.getSessionKeyInt('invoiceTemplate', InvoiceTemplateEnum.REPUBLIC_PALAZA),
          is_price_contain: this.SquareChecked,
          picked: this.picked,
          list_invoice_ids: list_ids,
          exclude_invoice_ids: list_exclude_ids,
          invoiceType: this.invoiceType,
          accountingPeriod: utils.formatSqlDate(this.periodSelected, "YYYY/MM", "YYYYMM"),
          printInvoiceType: this.printInvoiceType,
          lastPaymentDate: this.lastPaymentDate,
          searchData: JSON.stringify(searchData)
        }
      });
      window.open(routeData.href, "_blank");

      $(this.$refs[`modal-main-print-search`]).modal("hide");
    },
    onExportInvoiceToExcel() {
      $(this.$refs[`modal-main-export-excel`]).modal("hide");
      this.doExportPdf();
    },
    onPrintInvoiceByFilter() {
      $(this.$refs[`modal-main-print-search`]).modal("show");
      this.originalRecordData["id"] = "1";
    },
    onCancel: function() {
      $(this.$refs["modal-confirm-send-pdf"]).modal("hide");
      $(this.$refs["modal-warning-send-mail"]).modal("hide");
      this.isPrintMonth = false;
      const data = {
        params: {
          page: 1,
          period: moment(new Date()).format("YYYY-MM-DDThh:mm:ss"),
          flag: true,
          invoiceType: this.invoiceType
        }
      };
      this.GET_INVOICE_LIST_PERFORMANCE_VS2(data);
      this.$refs.lteTable.UnselectedAll();
    },
    onSelectedMonthSendMail: function() {
      const data = {
        params: {
          period: this.periodSelected,
          page_size: 10000,
          invoiceType: this.invoiceType
        }
      };
      this.GET_INVOICE_LIST_PERFORMANCE_VS2(data);
    },
    optionChangeTypeSendEmail: function() {
      this.isPrintMonth = false;
      const data = {
        params: {
          page: 1,
          period: moment(new Date()).format("YYYY-MM-DDThh:mm:ss"),
          flag: true,
          invoiceType: this.invoiceType
        }
      };
      this.GET_INVOICE_LIST_PERFORMANCE_VS2(data);
      this.$refs.lteTable.UnselectedAll();
    },
    onSendPdfToEmail(action_id) {
      if(action_id != 2){
         if (
        this.isPrintMonth == false &&
        this.invoiceInformationList.length == 0 
        ) {
          this.ON_SHOW_TOAST({
            message: "Vui lòng chọn phiếu báo để gửi",
            styleType: "danger"
          });
          return;
        }
      }
      let invoiceInvalid = false;
      if (this.multipleSendPdf) {
        for (
          let i = 0, size = this.list_invoice_status_code.length;
          i < size;
          i++
        ) {
          if (
            this.list_invoice_status_code[i] != "I" &&
            this.list_invoice_status_code[i] != "PP"
          ) {
            invoiceInvalid = true;
            break;
          }
        }
      } else {
        if (
          this.originalRecordData["invoice.status_code"] != "I" &&
          this.originalRecordData["invoice.status_code"] != "PP"
        ) {
          invoiceInvalid = true;
        }
      }
      if (!invoiceInvalid) {
        if (!this.multipleSendPdf) {
          let total_summary =
            parseInt(utils.removeSpecialCharacter(this.originalRecordData["invoice.total_fees"])) +
            parseInt(utils.removeSpecialCharacter(this.originalRecordData["total_liability_cash"]));

          this.originalRecordData["money_to_text_vi"] = utils.readMoney(total_summary, "vi");
          this.originalRecordData["money_to_text_en"] = utils.readMoney(total_summary, "en");

          // update total
          this.originalRecordData["invoice.total_fees_all"] = utils.formatNumber(total_summary);
        }
        let filter = {
          invoiceInformations: this.multipleSendPdf ? this.invoiceInformationList : [this.originalRecordData],
          selected: this.isPrintMonth
        };
        // loading when user click send selected mail
        if (!this.isPrintMonth) {
          this.isLoading = true;
        }

        // submit => close modal => fetch data again to avoid unwant UI
        if (this.isPrintMonth == true) {
          $(this.$refs["modal-confirm-send-pdf"]).modal("hide");
          $(this.$refs["modal-warning-send-mail"]).modal("hide");
          const data = {
            params: {
              page: 1,
              period: moment(new Date()).format("YYYY-MM-DDThh:mm:ss"),
              flag: true,
              invoiceType: this.invoiceType
            }
          };
          this.GET_INVOICE_LIST_PERFORMANCE_VS2(data);
          this.$refs.lteTable.UnselectedAll();
          this.isLoading = false;
        }
        // send mail invoice
        this.SEND_INVOICE_INFORMATION_TO_USER(filter).then(
          function(res) {
            this.SUCCESS_TOAST();
            this.isLoading = false;
          }.bind(this)
        ).catch(
          function(error) {
            let error_code = error.response.data.message;
            if (error_code == "You must install template email for using") {
              this.ON_SHOW_TOAST({
                // message: 'Chưa hổ trợ template này',
                message: error_code,
                styleType: "danger"
              });
            } else {
              this.ON_SHOW_TOAST({
                message: "Chưa hổ trợ template này",
                styleType: "danger"
              });
            }
            this.isLoading = false;
          }.bind(this)
        );
      } else {
        this.ON_SHOW_TOAST({
          message: "Không thể gửi cho phiếu báo đã thanh toán",
          styleType: "danger"
        });
      }
      $(this.$refs[`modal-confirm-send-pdf`]).modal("hide");
    },
    addReceiptForInvoice(invoiceItem, amount) {
      let data = {
        invoiceId: invoiceItem.id,
        payAmount: amount,
        description: this.paymentNote
      };
      this.isLoading = true
      this.ADD_RECEIPT_FOR_INVOICE(data)
      .then(
        function() {
          this.isLoading = false
          this.SUCCESS_TOAST();
          $(this.$refs[`modal-process-payment`]).modal("hide");
        }.bind(this)
      )
      .catch(
        function(error) {
          this.isLoading = false
          this.ERROR_TOAST();
        }.bind(this)
      );
    },
    onProcessPayment(invoiceItem) {
      let total_fees = utils.formatInteger(invoiceItem['invoice.total_fees'].toString())
      // let total_fees = parseInt(utils.removeSpecialCharacter(invoiceItem["invoice.total_fees"]))
      if (this.picked == 1) {
        this.addReceiptForInvoice(invoiceItem, total_fees)
      } else if (this.picked == 2) {
        let payment_value = parseInt(this.paymentValue)
        if (isNaN(payment_value)) {
          this.ON_SHOW_TOAST({
            message: "Vui lòng nhập giá trị cần thanh toán",
            styleType: "danger"
          });
        } else if (payment_value <= 0) {
          this.ON_SHOW_TOAST({
            message: "Giá trị cần thanh toán phải lớn hơn 0",
            styleType: "danger"
          });
        } else if (payment_value > total_fees) {
          this.ON_SHOW_TOAST({
            message: "Giá trị cần thanh toán phải nhỏ hơn hoặc bằng " + invoiceItem['invoice.total_fees'],
            styleType: "danger"
          });
        } else {
          this.addReceiptForInvoice(invoiceItem, payment_value)
        }
      }
    },
    clickToSmallBox() {
      alert("click!!!: clickToSmallBox");
    },
    addNew: function() {
      this.$router.push({
        name: "InvoiceAdd",
        params: {
          id: 0
        }
      });
    },
    // [loitt] - #905 Cho phép chuyển phiếu báo vô công nợ
    onCreateLiabilit: function() {
      let isAvailableLiabilit = false;
      if (this.invoiceInformationList.length <= 0) {
        this.ON_SHOW_TOAST({
          message: this.$t("invoice.liability.error_not_select_invoice"),
          styleType: "danger"
        });
        return;
      } else {
        this.invoiceExportLiabilitList = [];
        this.invoiceNotExportLiabilitList = [];
        let noOfInvoiceExportLiabilit = 0;
        let noOfInvoiceNotExportLiabilit = 0;
        for (
          let i = 0, size = this.invoiceInformationList.length;
          i < size;
          i++
        ) {
          if (this.invoiceInformationList[i].exported_to_liability == "false") {
            isAvailableLiabilit = true;
            let object = {
              no: (noOfInvoiceExportLiabilit += 1),
              invoice_number: this.invoiceInformationList[i].invoice_number,
              apartment_code: this.invoiceInformationList[i].apartment_code,
              owner_resident: this.invoiceInformationList[i][
                "invoice.owner"
              ]
            };
            this.invoiceExportLiabilitList.push(object);
          } else {
            let object = {
              no: (noOfInvoiceNotExportLiabilit += 1),
              invoice_number: this.invoiceInformationList[i].invoice_number,
              apartment_code: this.invoiceInformationList[i].apartment_code,
              owner_resident: this.invoiceInformationList[i][
                "invoice.owner"
              ]
            };
            this.invoiceNotExportLiabilitList.push(object);
          }
        }
      }
      if (isAvailableLiabilit) {
        $(this.$refs[`modal-main-liability`]).modal("show");
      } else {
        this.ON_SHOW_TOAST({
          message: "Tất Cả Phiếu Báo Được Chọn Đã Chuyển Vô Công Nợ",
          styleType: "danger"
        });
      }
    },
    // [loitt] - #905 Cho phép chuyển phiếu báo vô công nợ
    onSaveLiability: function() {
      this.isLoading = true;
      let data = {
        invoice_list_id: this.list_invoice_id,
        user_created: this.GET_ACCOUNT_DATA.id
      };
      // init empty
      this.resultImportList = [];
      this.CREATE_ACCOUNTING_HOME_LIABILITY_FROM_INVOICE(data).then(
        function(res) {
          this.ON_SHOW_TOAST({
            message: this.$t("invoice.liability.success"),
            styleType: "success"
          });
          this.isLoading = false;
        }.bind(this)
      )
      .catch(
        function(error) {
          this.ON_SHOW_TOAST({
            message: error,
            styleType: "danger"
          });
          this.isLoading = false;
        }.bind(this)
      );

      $(this.$refs[`modal-main-liability`]).modal("hide");
    },

    onExport: function() {
      $(this.$refs[`modal-main-export-excel`]).modal("show");
    },
    doExportPdf: async function() {
      this.json_data_export = [];

      if (this.picked == 1) {
        if (utils.isEmptyString(this.periodSelected)) {
          this.ON_SHOW_TOAST({
            message: this.$t("invoice.month"),
            styleType: "danger"
          });
        } else {
          const data = {
            params: {
              filter_no_page: this.filterDataOnTable,
              accountingPeriod: utils.formatSqlDate(this.periodSelected, "YYYY/MM", "YYYYMM"),
              invoiceType: this.invoiceType
            }
          };
          this.isLoading = true;
          await this.GET_FILTER_INVOICE_LIST(data).then(
            function() {
              this.dataExport.forEach(v => {
                let json_data = this.getDataExportExcel(v);
                this.json_data_export.push(json_data);
              });
              this.isLoading = false;
            }.bind(this)
          );
          this.exportExcelFunction()
        }
      } else {
        const data = {
          params: {
            filter_no_page: this.filterDataOnTable,
            invoice_number: this.search.invoice_number,
            apartment_code: this.search.apartment_code,
            owner_apartment: this.search.owner_apartment,
            user_name: this.search.user_name,
            status_name: this.invoiceStatusSelect,
            date_issued: this.search.date_issued,
            date_paid: this.search.date_paid,
            other_details: this.search.other_details,
            total_fees: this.search.total_fees,
            due_date: this.search.due_date,
            note: this.search.note,
            dateViewOptions: this.dateViewOption,
            isViewDetail: this.isViewDetail,
            invoiceType: this.invoiceType,
            accountingPeriod: this.search.datePickerValue
          }
        };
        this.isLoading = true;
        await this.GET_FILTER_INVOICE_LIST(data).then(
          function() {
            this.dataExport.forEach(v => {
              let json_data = this.getDataExportExcel(v);
              this.json_data_export.push(json_data);
            });
            this.isLoading = false;
          }.bind(this)
        );
        this.exportExcelFunction()
      }
    },
    exportExcelFunction: function() {
      if (this.json_data_export.length <= 0) {
        this.ON_SHOW_TOAST({
          message: this.$t("invoice.toast.error_export_excel"),
          styleType: "danger"
        });
        return;
      } else {
        // export json to Worksheet of Excel
        // only array possible
        var invoices = XLSX.utils.json_to_sheet(this.json_data_export);
        // var pokemonWS = XLSX.utils.json_to_sheet(this.Datas.pokemons)

        // A workbook is the name given to an Excel file
        var wb = XLSX.utils.book_new(); // make Workbook of Excel

        // add Worksheet to Workbook
        // Workbook contains one or more worksheets
        XLSX.utils.book_append_sheet(wb, invoices, "Hóa Đơn"); // sheetAName is name of Worksheet
        // XLSX.utils.book_append_sheet(wb, pokemonWS, 'pokemons')

        var wscols = [
          { wch: 15 }, // Mã Thanh Toán
          { wch: 10 }, // Mã Căn Hộ
          { wch: 40 }, // Thông Tin Chủ Hộ
          { wch: 40 }, // Xuất Hóa Đơn Tới
          { wch: 20 }, // Tình Trạng
          { wch: 15 }, // Ngày Phát Hành
          { wch: 15 }, // Ngày Trả
          { wch: 15 }, // Tổng Phí
          { wch: 10 }, // Hạn Chót
          { wch: 50 } // Ghi Chú
        ];

        invoices["!cols"] = wscols;

        // export Excel file
        XLSX.writeFile(wb, "Invoices.xlsx"); // name of the file is 'book.xlsx'
      }
    },
    executeChangeIssuedToPaid: function() {
      this.isLoading = true;
      let payload = {
        list_invoice_id: this.list_invoice_id,
        create_by_user_id: this.GET_ACCOUNT_DATA.id
      };

      this.CHANGE_ISSUED_TO_PAID(payload)
        .then(
          function() {
            this.SUCCESS_TOAST();
            const data = {
              params: {
                page: 1,
                invoiceType: this.invoiceType
              }
            };
            this.GET_INVOICE_LIST_PERFORMANCE_VS2(data);
            this.isLoading = false;
          }.bind(this)
        )
        .catch(
          function(error) {
            this.ON_SHOW_TOAST({
              message: this.messages[error.response.data.message],
              styleType: "danger"
            });
            this.isLoading = false;
          }.bind(this)
        );
    },
    crudActions: function(recordData, actionsType, isModalVisible) {
      if (actionsType == LTEActionTypeEnum.MODIFY) {
        this.$router.push({
          name: "InvoiceAdd",
          params: {
            id: recordData.id
          },
          query: this.$route.query
        });
      } else if (actionsType == LTEActionTypeEnum.PAYMENT) {
        this.originalRecordData = recordData;
        this.picked = 1
        this.payAmount = null
        this.paymentNote = null
        $(this.$refs[`modal-process-payment`]).modal("show");
      } else if (actionsType == LTEActionTypeEnum.PRINT) {
        this.originalRecordData = recordData;
        this.onPrintInvoice()
        // $(this.$refs[`modal-main-print`]).modal("show");
      } else if (actionsType == LTEActionTypeEnum.SEND_PDF) {
        this.originalRecordData = recordData;
        this.full_name = recordData["invoice.owner"];
        this.showModalConfirmSendPdf(false);
      } else {
        this.originalRecordData = recordData;
        this.isModalVisible = isModalVisible;
      }
    },
    filterData: function(searchQuery) {
      this.filterDataOnTable = searchQuery;
      if (searchQuery != "") {
        const data = {
          params: {
            page: 1,
            filter: searchQuery,
            invoiceType: this.invoiceType
          }
        };
        this.GET_INVOICE_LIST_PERFORMANCE_VS2(data);
      }
    },
    selectedItems: function(item_invoices, isSelectedAll) {
      let result = []
      this.isSelectedAll = isSelectedAll;
      this.list_invoice_id = [];
      this.list_invoice_number = [];
      this.list_invoice_apartment_code = [];
      this.list_invoice_status_code = [];
      // this.countPaid = 0;
      // this.countNotPaid = 0;
      this.countTotal = 0;
      for (let i = 0, size = item_invoices.length; i < size; i++) {
        let item = {...item_invoices[i]}
        this.list_invoice_status_code.push(
          item["invoice.status_code"]
        );
        this.list_invoice_id.push(item.id);
        this.list_invoice_number.push(item.invoice_number);
        this.list_invoice_apartment_code.push(item.apartment_code);
        let total_summary =
          parseInt(utils.removeSpecialCharacter(item["invoice.total_fees"])) +
          parseInt(utils.removeSpecialCharacter(item["total_liability_cash"]));

        item["money_to_text_vi"] = utils.readMoney(total_summary, "vi");
        item["money_to_text_en"] = utils.readMoney(total_summary, "en");

        // update total
        item["invoice.total_fees_all"] = utils.formatNumber(total_summary);

        // Count paid, not paid, total
        // if (item["invoice.status_code"] == "I") {
        //   this.countNotPaid += parseInt(utils.formatInteger(item["invoice.total_fees"]));
        // } else if (item["invoice.status_code"] == "PP") {
        //   item.partial_paid_list.forEach(partial_paid => {
        //     if (partial_paid.status == "unpaid") {
        //       this.countNotPaid += partial_paid.total_fees;
        //     } else {
        //       this.countPaid += partial_paid.total_fees;
        //     }
        //   });
        // } else if (item["invoice.status_code"] == "P") {
        //   this.countPaid += parseInt(utils.formatInteger(item["invoice.total_fees"]));
        // }
        this.countTotal += parseInt(utils.formatInteger(item["invoice.total_fees"]));
        result.push(item)
      }
      this.invoiceInformationList = result;
      // Format number
      // this.countPaid = utils.formatNumber(this.countPaid);
      // this.countNotPaid = utils.formatNumber(this.countNotPaid);
      this.countTotal = utils.formatNumber(this.countTotal);
    },
    onConfirmChangedIssueToPaid: function() {
      this.isModalVisibleChangedIssueToPaid = false;
      this.executeChangeIssuedToPaid();
    },
    onConfirm: function() {
      this.isModalVisible = false;
      let status_code = this.originalRecordData["invoice.status_code"];
      if (status_code == "P" || status_code == "PP") {
        this.ON_SHOW_TOAST({
          message: this.$t("invoice.toast.error"),
          styleType: "danger"
        });
        return;
      }
      this.DELETE_INVOICE(this.originalRecordData).then(
        function() {
          let currentPage = this.PAGINATION.page;
          let totalPage = this.PAGINATOR.length;
          let page =
            currentPage >= totalPage && this.gridInvoiceDataList.length == 1
              ? totalPage - 1
              : currentPage;

          this.onSearchInvoice(page)
          this.SUCCESS_TOAST();
        }.bind(this)
      )
      .catch(
        function(error) {
          if (
            error.response.data.message.includes("invoice_moved_liability")
          ) {
            this.ON_SHOW_TOAST({
              message: this.$t(
                "invoice.modal_message.content_exported_to_liability"
              ),
              styleType: "danger"
            });
          } else {
            this.ON_SHOW_TOAST({
              message: error,
              styleType: "danger"
            });
          }
        }.bind(this)
      );
    },
    onHandleChangeMonth: function(value) {
      this.periods.forEach(el => {
        // let getTimePeriod = el.date_from.replace("-", "/").slice("-", 7);
        if (el.date_from == value) {
          this.search.period = el.value;
        }
      });
    },
    onPagination: function(data) {
      //data.params.filter = this.filterDataOnTable;
      this.onSearchInvoice(data.params.page);
    },
    closeModal() {
      this.isModalVisible = false;
      this.isModalVisibleChangedIssueToPaid = false;
    },
    onSelectedMonth: function() {
      // periodSelected
    },
    importExcel: function() {
      this.$router.push({
        name: "InvoiceImportExcel",
        params: {
          id: 0
        },
        query: this.$route.query
      });
    },
    onShowModalSendNotification: function () {
      this.$refs.sendEmailAndNotificationInvoice.onShowModal(
        this.invoiceType,
        Enum.invoiceActionSendEmailAndNotification.NOTIFICATION,
        this.list_invoice_id)
    },
    onShowModalSendInvoiceEmail: function (sendInvoiceType) {
      let searchData = {
        invoiceNumber: this.search.invoice_number,
        apartmentCode: this.search.apartment_code,
        ownerApartment: !utils.isEmptyString(this.search.owner_apartment) ? this.search.owner_apartment.toLowerCase() : null,
        accountingPeriod: this.search.datePickerValue,
        apartmentGroupIdFilter: this.apartmentGroupIdFilter,
        dateCreatedInvoiceFrom: this.search.dateCreatedInvoice.start,
        dateCreatedInvoiceTo: this.search.dateCreatedInvoice.end,
        invoiceStatus: this.search.status
      }
      this.$refs.sendEmailAndNotificationInvoice.onShowModal(
        this.invoiceType,
        Enum.invoiceActionSendEmailAndNotification.SEND_EMAIL,
        this.list_invoice_id,
        sendInvoiceType,
        searchData)
    },
    callbackInvoiceList: function () {
      let currentPage = this.PAGINATION.page;
      let totalPage = this.PAGINATOR.length;
      let page =
        currentPage >= totalPage && this.gridInvoiceDataList.length == 1
          ? totalPage >= 2 ? totalPage - 1 : 1
          : currentPage;
      this.onSearchInvoice(page)
    },
    getDateDueInvoiceData: function() {
      let result = ''
      let formatDate = "YYYY-MM-DD"
      let toFormatDate = "DD/MM/YYYY"
      let monthlyDueDate = sessionStorage.getItem('projectMonthlyDueDate')
      let nowTime = moment().format(formatDate)
      let projectDueDate = null
      if (monthlyDueDate) {
        projectDueDate = utils.formatSqlDate(monthlyDueDate, "DD", formatDate)
        if (nowTime >= projectDueDate) {
          result = moment(projectDueDate, formatDate).add(1, 'month').format(toFormatDate)
        } else {
          result = utils.formatSqlDate(projectDueDate, formatDate, toFormatDate)
        }
      }
      return result
    },
    emitFilterApartmentInGroup: function(data) {
      this.apartmentGroupIdFilter = data
      this.onSearchInvoice(1)
    },
    sendInvoiceEmailToUser: function(invoiceId) {
      this.$refs.sendEmailAndNotificationInvoice.sendInvoiceEmailToUser(
        this.invoiceType,
        Enum.invoiceActionSendEmailAndNotification.SEND_EMAIL,
        [this.originalRecordData.id])
      $(this.$refs[`modal-confirm-send-pdf`]).modal("hide");
    },
    getQueryRouter: function() {
      let routerQuery = this.$route.query;
      let invoiceNumber = routerQuery && routerQuery.invoiceNumber
      let apartmentCode = routerQuery && routerQuery.apartmentCode
      let ownerApartment = routerQuery && routerQuery.ownerApartment
      let datePickerValue = routerQuery && routerQuery.datePickerValue
      let invoiceStatus = routerQuery && routerQuery.invoiceStatus
      let invoiceType = routerQuery && routerQuery.invoiceType

      this.search.invoice_number = invoiceNumber
      this.search.apartment_code = apartmentCode
      this.search.owner_apartment = ownerApartment
      this.search.datePickerValue = utils.formatSqlDate(datePickerValue, "YYYY/MM", "YYYYMM")
      this.search.status = invoiceStatus
      if (invoiceType != undefined) {
        this.invoiceType = parseInt(invoiceType);
      }
    },
    onChangeSeviceInvoiceType: function () {
      if (this.invoiceType === Enum.invoiceTypeEnum.MONTHLY) {
        this.modalTitle = 'invoice.modal_delete_invoice.deleteMonthlyTitle'
      } else if (this.invoiceType === Enum.invoiceTypeEnum.QUATERLY) {
        this.modalTitle = 'invoice.modal_delete_invoice.deleteManagementTitle'
      }
    },
    onEmitSelectInvoiceType: function() {
      this.$emit("onChangeInvoiceType", this.invoiceType)
      this.onSearchInvoice(1);
    },
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "PAGINATION_PREV_PAGE",
      "PAGINATION_NEXT_PAGE",
      "GET_INVOICE_LIST_PERFORMANCE_VS2",
      "DELETE_INVOICE",
      "ON_SHOW_TOAST",
      "GET_FILTER_INVOICE_LIST",
      "CHANGE_ISSUED_TO_PAID",
      "SAVE_CUSTOMIZE_TABLE_PERSONAL_CONFIG",
      "GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG",
      "SEND_INVOICE_INFORMATION_TO_USER",
      "CREATE_ACCOUNTING_HOME_LIABILITY_FROM_INVOICE",
      "ADD_RECEIPT_FOR_INVOICE",
      "CONVERT_TO_EINVOICE_BKAV"
    ])
  },
  created() {
    let params = this.$route.params;
    this.isViewDetail = !utils.isNull(params.isViewDetail) ? params.isViewDetail : "False";
    this.dateViewOption = sessionStorage.getItem('projectDateViewOptions');
    if (this.isViewDetail == "True") {
      this.options.format = this.dateViewOption.slice(3);
    } else {
      this.options.format = this.dateViewOption;
    }
  },
  async mounted() {
    // fix show multiple modal
    $(document).on("hidden.bs.modal", ".modal", function() {
      $(".modal:visible").length && $(document.body).addClass("modal-open");
    });
    // this.optionsPicker.maxDate = moment().format('YYYY/MM')
    //   .replace("-", "/")
    //   .slice("-", 7);
    this.columnsInvoice.data_list = this.gridColumns;
    const filter = {
      params: {
        tablename: "invoicelist"
      }
    };
    await this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG(filter);
    this.onChangeSeviceInvoiceType()
    let onTabSelect = this.$route.query.onTabSelect;
    if (onTabSelect != undefined && parseInt(onTabSelect) === 0) {
      this.getQueryRouter()
      this.onSearchInvoice(1)
    }
  },

  components: {
    "lte-button": LTEButton,
    "lte-table": LTETable,
    "lte-modal": LTEModal,
    "lte-core-alert": LTECoreAlert,
    "date-picker": datePicker,
    "select-option-check": SelectOptionCheck,
    "modal-delete-invoice": ModalDeleteInvoice,
    "modal-create-liabilities": ModalCreateLiabilities,
    paginator: Paginator,
    loading: Loading,
    sendEmailAndNotificationInvoice,
    ApartmentGroupFilterComponent
    //ConvertToBKAV
  }
};
</script>

<style lang="scss" scoped>
.search {
  box-shadow: none;
  border-color: #d2d6de;
  z-index: 2;
  float: left;
  margin-bottom: 8px;
  margin-right: 5px;
  height: 30px;
  font-size: 12px;
  line-height: 1.5;
  border-radius: 3px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.select-option-invoice {
  margin-top: -12px;
  display: inline-block;
}
@media only screen and (max-width: 1000px) {
  .select-option-invoice {
    float: none;
    margin-top: 4px;
  }
}
@media only screen and (max-width: 768px) {
  .select-option-invoice {
    float: none;
    margin-top: 0px;
  }
}

.size-180 {
  width: 180px;
}

.label_choose_print {
  margin-bottom: 2%;
}

#checkboxesInvoice {
  display: flex;
  margin-top: 3%;
}

.checkbox_has_amount {
  display: inline;
  margin-right: 2rem;
}
.search-tools {
  padding-right: 0px;
  padding-left: 0px;
  width: auto;
}
.send-email-invoice-item {
  padding: 5px 15px
}
.send-email-invoice-item:hover {
  background-color: #eee;
  color: #2e2e2e;
  outline: 0;
  text-decoration: none;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/Invoice/ServicesInvoiceManagement.vue